<template>
  <div class="container">
    <div class="containter-fluid">
      <unique-selling-points></unique-selling-points>
      <div class="content-low row align-items-start justify-content-between">
        <FAQ v-if="!isGeneric" :page="faqpage" />
        <content-card
          :title="'pv_contactblock_title'"
          :text="'pv_contactblock_text'"
          :imgSrc="'images/consultant.jpg'"
          :circleImage="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FAQ from '@/components/main/faq/FAQ'
import ContentCard from '@/components/main/content/ContentCard'
import UniqueSellingPoints from '@/components/parts/UniqueSellingPoints'
import { mapGetters } from 'vuex'

export default {
  name: 'ContentLow',
  computed: {
    faqpage() {
      return this.trsMode ? 'trs-faqs' : 'iquote'
    },
    ...mapGetters(['isGeneric']),
  },
  components: {
    FAQ,
    ContentCard,
    UniqueSellingPoints,
  },
}
</script>
